import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackInitiateCheckout } from '../MetaPixel';
import { checkoutUrl } from '../../data/offer';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'lg';
  arrow?: boolean;
  href?: string;
  target?: '_blank';
  rel?: string;
  onClick?: () => void;
  ariaLabel?: string;
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'lg',
  arrow = false,
  href,
  target,
  rel,
  onClick,
  ariaLabel
}: ButtonProps) {
  const styles = {
    primary: 'bg-orange-500 text-zinc-950 shadow-lg shadow-orange-500/20 ring-1 ring-inset ring-black/10 transition-[background-color,transform] hover:bg-orange-400 active:scale-[0.98]',
    secondary: 'bg-zinc-900 text-white border border-teal-700/40 transition-[background-color,transform] hover:bg-zinc-800 active:scale-[0.98]',
    outline: 'border-2 border-teal-700 bg-transparent text-teal-400 transition-colors hover:bg-zinc-900'
  };
  const sizes = {
    sm: 'px-6 py-3.5 text-sm',
    lg: 'px-7 py-5 text-base sm:px-12 sm:py-6 sm:text-lg'
  };
  const classes = `inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl font-extrabold uppercase tracking-wide duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-orange-400/50 ${styles[variant]} ${sizes[size]} ${className}`;
  if (href) {
    const handleClick = () => {
      if (href === checkoutUrl) trackInitiateCheckout();
      onClick?.();
    };
    return <a href={href} target={target} rel={rel} className={classes} aria-label={ariaLabel} onClick={handleClick} data-id="element-202" data-mp="1cdesdks1kwxk">
        {children}
        {arrow && <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-203" data-mp="17fmri19f60h8" />}
      </a>;
  }
  return <button type="button" onClick={onClick} className={classes} aria-label={ariaLabel} data-id="element-204" data-mp="1ldbf3guvflpz">
      {children}
      {arrow && <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-205" data-mp="1hdsruefkuyjz" />}
    </button>;
}